BinderPrematchSingleSport = window.BinderPrematchSingleSport = (function () {
    const selectors = {

        vmSelectAll: '#sports-filter__select-all',
        vmSportsFilterItem: '.sports-filter__item',
        vmSportsFilterItemsContainer: '#vm-sports-filter-items',

        tbTable: '.events-table',
        tbEvent: '.events-table__body-row',
        searchEvent: '[search-event]',

        tbFavstar: '[tb-favstar]',
        searchFavstar: '[search-favstar]',


        emptyBetplace: '#empty_betplace',

        tbSport: '.events-table',
        tbExpandSport: '.js-expand-table',
        tbLeague: '.js-expand-league',
        tbLeagueBody: '.mode-table__group-body',

        cmTimeOffset: '#cm-time_offset',
    };

    var sportType;

    var bindUI = function () {
        var body = app.body;

        // Toggle League v2.5
        body.on('click', selectors.tbLeague, function () {
            var that = $(this).closest('.events-table__group'),
                id = that.data('id'),
                tId = that.closest(selectors.tbSport).data('id');

            app.enableLoading();
            if (that.hasClass('m-expanded')) {
                Ajax.postJson('/Prematch/CollapseNode', {
                    data: {
                        id: id,
                        sportType: sportType
                    },
                    doCallAjaxViewParsers: false,
                    success: function () {
                        that.removeClass('m-expanded').addClass('m-collapsed');
                        that.find(selectors.tbLeagueBody).remove();
                        app.ModeTablePrematch.shrinkTable(tId);
                        app.disableLoading();
                    }
                });
                return false;
            }
            Ajax.postJson('/Prematch/ExpandLeague', {
                data: {
                    id: id,
                    sportType: sportType
                },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTablePrematch.extendTable(tId);
                    app.disableLoading();
                }
            });
            return false;
        });


        // Set TimeOffset v2.0
        body.on('change', selectors.cmTimeOffset, function () {
            app.enableLoading();
            Ajax.postJson("/Prematch/SetTimeOffset", {
                data: {
                    to: $(this).val(),
                    sportType: sportType
                },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTablePrematch.update();
                    app.disableLoading();
                    (app.ModeTablePrematch.isEmpty()) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                }
            });
            return false;
        });

        // Fave event v3.0
        body.on('click', (selectors.tbFavstar + ',' + selectors.searchFavstar), function (e) {

            var that = $(this),
                isRemovingFromFav = that.hasClass('m-active'),
                eventId = (that.is(selectors.tbFavstar)) ? that.closest(selectors.tbEvent).data('id') : that.closest(selectors.searchEvent).data('id'),
                dataIdFilter = '[data-id=' + eventId + ']',
                allStars = $.merge($(selectors.tbEvent + dataIdFilter).find(selectors.tbFavstar), $(selectors.searchEvent + dataIdFilter).find(selectors.searchFavstar));

            app.enableLoading();
            Ajax.postJson(isRemovingFromFav ? "/Prematch/UnFaveEvent" : "/Prematch/FaveEvent", {
                data: {
                    id: eventId
                },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    if (resp && resp.Message) {
                        that.removeClass('m-active');
                        Tooltip.errorNode(that, resp.Message);
                        that.removeClass('m-loading');
                        return;
                    }

                    if (isRemovingFromFav) {
                        allStars.removeClass('m-active');
                        allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_10', 'Добавить в избранное'));
                    }
                    else {
                        allStars.addClass('m-active');
                        allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_11', 'Удалить из избранного'));
                    }

                    app.VerticalMenu.changeFavorites();

                    app.disableLoading();
                },
            });

            return;
        });
    };


    var unBindUI = function () {
        app.body
            .off('click', selectors.tbLeague)
            .off('click', (selectors.tbFavstar + ',' + selectors.searchFavstar))
            .off('change', selectors.cmTimeOffset);
    };

    function setScopeData(scopeData) {
        if (scopeData != undefined && scopeData.hasOwnProperty('sportType')) {
            sportType = scopeData.sportType;
        }
    }

    var bind = function (justLoaded, scopeData) { setScopeData(scopeData); bindUI(); }
    var unBind = function () { unBindUI(); }

    return {
        bind: bind,
        unBind: unBind,
        name: 'BinderPrematchSingleSport',
        url: BinderPrematch.url
    };
}());

//-----------------------------------

ScopePrematchSingleSport = (function () {

    var sportType;

    function init() {
        app.VerticalMenu.init();
        app.ModeTablePrematch.init();
        app.Search.init('prematchSingleSport', { sportType: sportType });
    }

    function dispose() {
        app.ModeTablePrematch.dispose();
        app.VerticalMenu.dispose();
    }

    var start = function (justLoaded, scopeData) { sportType = scopeData.sportType; init(); };
    var stop = function () { dispose(); };

    return {
        start: start,
        stop: stop,
        name: 'ScopePrematchSingleSport',
        url: 'PREMATCH/SPORT'
    };
}());
